/**
 * Записи визитов и тепловые карты Umami (ISSUE-147): рекордер `/u/r.js` (rrweb) пишет DOM интерфейса и клики. Холст
 * Pixi не пишется — `recordCanvas: false` зашит в рекордер, поле в записи пустое, видны окна, кнопки и куда тапали.
 * Поля ввода маскирует сам рекордер (`maskLevel` из настроек сайта в Umami).
 *
 * Рекордер вешает запись на визит по токену `cache` из ответа `/u/api/send` (`window.umami.getSession()`), без токена
 * кусок записи молча теряется. Поэтому он грузится только после первой принятой отправки: ворота аналитики (браузер —
 * после первого действия, Mini App — сразу), `qa-*` и тестовый аккаунт до отправки не доходят. Токен однажды выдан и
 * не обнуляется (грабли Sapero #164: identify обнулял кеш и терял начало записи).
 */
export const RECORDER_PATH = "/u/r.js";

export interface RecorderDeps {
  doc: Pick<Document, "createElement" | "head">;
  win: { umami?: unknown };
  websiteId: string;
  /** Текущий токен визита. */
  cache(): string | null;
}

/** Подключить рекордер один раз; повторный вызов ничего не делает. */
export function createRecorder(deps: RecorderDeps): { start(): void; started(): boolean } {
  let started = false;
  return {
    start() {
      if (started || !deps.cache()) return;
      started = true;
      // рекордер читает только getSession().cache; трекера Umami (`s.js`) в игре нет, события шлёт свой модуль
      deps.win.umami ??= { getSession: () => ({ cache: deps.cache(), website: deps.websiteId }) };
      const script = deps.doc.createElement("script");
      script.src = RECORDER_PATH;
      script.async = true;
      script.setAttribute("data-website-id", deps.websiteId);
      deps.doc.head.append(script);
    },
    started: () => started,
  };
}
